


















export default {
    name: 'ChooseGroupItemLayout',
};
